// extracted by mini-css-extract-plugin
export default {"root":"tag_root__M4AIE","red":"tag_red__Xrnsm","green":"tag_green__QRjZk"};